import { MODALIDADES } from "../../constants";
import { DEFAULT_PLATFORMS } from "../../services/platformCatalog";
import { fmtDate } from "../../services/formatting";
import { getCurrencyLabel, getPlatformCurrency } from "../../services/currency";
import {
  sanitizeNonNegativeInput,
} from "../../utils/nonNegativeInput";

export default function TorneioInlineEditRow({
  tournament,
  usos,
  index,
  form,
  errors,
  onChange,
  onSave,
  onCancel,
}) {
  const naturalCurrency = getPlatformCurrency(form.plataforma);
  const handleChange = (field, value) => {
    onChange({ ...form, [field]: value });
  };

  return (
    <div>
      {index > 0 && <hr className="divider" />}
      <div
        className={`tr torneios-table__row torneios-table__row--editing motion-list-row motion-list-row--${Math.min(index, 8)}`}
      >
        <div className="torneios-table__edit-field">
          <input
            className="input-field torneios-table__edit-control"
            type="text"
            maxLength={50}
            value={form.nome}
            onChange={(event) => handleChange("nome", event.target.value)}
          />
          {errors.nome && (
            <span className="torneios-table__edit-error">{errors.nome}</span>
          )}
        </div>

        <div className="torneios-table__edit-field">
          <input
            className="input-field torneios-table__edit-control"
            type="number"
            min="0"
            value={form.buyin}
            onChange={(event) =>
              handleChange("buyin", sanitizeNonNegativeInput(event.target.value, 9))
            }
          />
          <span className="currency-field-note">
            {getCurrencyLabel(naturalCurrency)}
          </span>
          {errors.buyin && (
            <span className="torneios-table__edit-error">{errors.buyin}</span>
          )}
        </div>

        <div className="torneios-table__edit-field">
          <select
            className="input-field torneios-table__edit-control"
            value={form.plataforma}
            onChange={(event) => handleChange("plataforma", event.target.value)}
          >
            <option value="">Plataforma</option>
            {DEFAULT_PLATFORMS.map((platform) => (
              <option key={platform} value={platform}>
                {platform}
              </option>
            ))}
          </select>
          {errors.plataforma && (
            <span className="torneios-table__edit-error">{errors.plataforma}</span>
          )}
        </div>

        <div className="torneios-table__edit-field">
          <select
            className="input-field torneios-table__edit-control"
            value={form.modalidade}
            onChange={(event) => handleChange("modalidade", event.target.value)}
          >
            {MODALIDADES.map((modalidade) => (
              <option key={modalidade} value={modalidade}>
                {modalidade}
              </option>
            ))}
          </select>
          {form.modalidade === "SAT" && (
            <input
              className="input-field torneios-table__edit-control"
              type="number"
              min="0"
              placeholder="Ticket"
              value={form.valorTicket}
              onChange={(event) =>
                handleChange("valorTicket", sanitizeNonNegativeInput(event.target.value, 9))
              }
            />
          )}
        </div>

        <div className="torneios-table__date">
          {fmtDate(tournament.criadoEm)}
          <span className="torneios-table__usage">
            {usos} registro{usos !== 1 ? "s" : ""}
          </span>
        </div>

        <div className="torneios-table__actions torneios-table__actions--editing">
          <button className="btn-icon btn-edit" title="Salvar" onClick={onSave}>
            OK
          </button>
          <button className="btn-icon btn-del" title="Cancelar" onClick={onCancel}>
            X
          </button>
        </div>
      </div>
    </div>
  );
}
